import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { array, object, string } from "yup";
import { SubCourseFormValues } from "src/models/SubCourse.model";
import SubCourseForm from "../Layout/SubCourseForm";
import {
  useViewSingleByIdSubCourseQuery,
  useEditSubCourseMutation,
} from "src/services/CourseServices";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";

type Props = {
  onClose: () => void;
  subCourseId: string;
};

const EditSubCourseFormWrapper = ({ onClose, subCourseId }: Props) => {
  const { data, isFetching, isLoading } =
    useViewSingleByIdSubCourseQuery(subCourseId); 

    const { courseId } = useParams();

  const [editSubCourse] = useEditSubCourseMutation();
  const [subCourseData, setSubCourseData] = useState<any>();

  //USEffect
  useEffect(() => {
    if (!isLoading && !isFetching) {
      setSubCourseData(data?.data);
    }
  }, [isFetching, isLoading, data]);

  // Form Initial Values
  const initialValues: SubCourseFormValues = {
    name: subCourseData?.name || "",
    PlanDetails: subCourseData?.planDetails?.map((el: any) => {
      return {
        plan: {
          label: el?.planName,
          value: el?.planId,
        },
        noOfDays: el?.noOfDays,
        fees: el?.fees,
        startDay: el?.startDay
          ? { label: el?.startDay, value: el?.startDay }
          : "",
        endDay: el?.endDay ? { label: el?.endDay, value: el?.endDay } : "",
      };
    }),
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string().required("Please enter name"),
    PlanDetails: array().of(
      object({
        fees: string().required("Please enter fees"),
        startDay: object().required("Please select start day"),
        endDay: object().required("Please select end day "),
      })
    ),
  });

  // Handle Submit
  const handleSubmit = (
    values: SubCourseFormValues,
    { setSubmitting, resetForm }: FormikHelpers<SubCourseFormValues>
  ) => {
    const formattedValues = {
      courseId: courseId,
      name: values?.name,
      planDetails: values?.PlanDetails?.map((el: any) => {
        return {
          planName: el?.plan?.label || "",
          planId: el?.plan?.value || "",
          fees: el?.fees || "",
          noOfDays: el?.noOfDays,
          startDay: el?.startDay?.value || "",
          endDay: el?.endDay?.value || "",
        };
      }),
    };
    editSubCourse({ body: formattedValues, id: subCourseId }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };

  return (
    <Dialog open maxWidth="xl" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <SubCourseForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Update"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditSubCourseFormWrapper;
